<template>
  <Layout>
    <b-row v-if="$can('GetReportPurchaseRequisitionView', 'permissions')">
      <b-col sm="12" md="12">
        <b-card>
          <b-row class="mt-3">
            <b-col sm="12" md="2" lg="2">
              <custom-date-picker
                v-model="filter.StartDate"
                format="DD.MM.YYYY"
                type="date"
                @input="Refresh"
                :clearable="false"
                :placeholder="$t('StartDate')"
                @keyup="BindValueStartDate"
              >
              </custom-date-picker>
            </b-col>
            <b-col sm="12" md="2" lg="2">
              <custom-date-picker
                v-model="filter.EndDate"
                format="DD.MM.YYYY"
                type="date"
                @input="Refresh"
                :clearable="false"
                :placeholder="$t('EndDate')"
                @keyup="BindValueEndDate1"
              >
              </custom-date-picker>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col sm="12" md="6">
        <b-card>
          <div class="card-body">
            <h4 class="card-title mb-4">{{ $t("Milliydo`kon.uzex.uz") }}</h4>
            <!-- Bar Chart -->
            <apexchart
              class="apex-charts"
              height="350"
              type="bar"
              dir="ltr"
              :series="dashboard1.series"
              :options="dashboard1.chartOptions"
            ></apexchart>
          </div>
        </b-card>
      </b-col>
      <b-col sm="12" md="6">
        <b-card>
          <div class="card-body">
            <h4 class="card-title mb-4">{{ $t("shop.uzex.uz") }}</h4>
            <!-- Bar Chart -->
            <apexchart
              class="apex-charts"
              height="350"
              type="bar"
              dir="ltr"
              :series="dashboard2.series"
              :options="dashboard2.chartOptions"
            ></apexchart>
          </div>
        </b-card>
      </b-col>
      <b-col sm="12" md="6">
        <b-card>
          <div class="card-body">
            <h4 class="card-title mb-4">{{ $t("Etender.uzex.uz") }}</h4>
            <!-- Bar Chart -->
            <apexchart
              class="apex-charts"
              height="350"
              type="bar"
              dir="ltr"
              :series="dashboard3.series"
              :options="dashboard3.chartOptions"
            ></apexchart>
          </div>
        </b-card>
      </b-col>
      <b-col sm="12" md="6">
        <b-card>
          <div class="card-body">
            <h4 class="card-title mb-4">{{ $t("To`g`ridan to`gri") }}</h4>
            <!-- Bar Chart -->
            <apexchart
              class="apex-charts"
              height="350"
              type="bar"
              dir="ltr"
              :series="dashboard4.series"
              :options="dashboard4.chartOptions"
            ></apexchart>
          </div>
        </b-card>
      </b-col>
      <b-col sm="12" md="6">
        <b-card>
          <div class="card-body">
            <h4 class="card-title mb-4">{{ $t("Eng yaxshi taklif") }}</h4>
            <!-- Bar Chart -->
            <apexchart
              class="apex-charts"
              height="350"
              type="bar"
              dir="ltr"
              :series="dashboard5.series"
              :options="dashboard5.chartOptions"
            ></apexchart>
          </div>
        </b-card>
      </b-col>
      <b-col sm="12" md="6">
        <b-card>
          <div class="card-body">
            <h4 class="card-title mb-4">{{ $t("Auksion") }}</h4>
            <!-- Bar Chart -->
            <apexchart
              class="apex-charts"
              height="350"
              type="bar"
              dir="ltr"
              :series="dashboard6.series"
              :options="dashboard6.chartOptions"
            ></apexchart>
          </div>
        </b-card>
      </b-col>
      <b-col sm="12" md="12">
        <b-card>
          <div class="card-body">
            <h4 class="card-title mb-4">{{ $t("chart4") }}</h4>
            <b-button-group>
              <b-button
                :variant="tabIndex == 0 ? 'primary' : 'outline-primary'"
                @click="Dashboard1"
                >{{ $t("GetAuctionInfoByStatusAuction") }}</b-button
              >
              <b-button
                :variant="tabIndex == 1 ? 'primary' : 'outline-primary'"
                @click="Dashboard2"
                >{{ $t("GetAuctionInfoByStatusEtender") }}</b-button
              >
              <b-button
                :variant="tabIndex == 2 ? 'primary' : 'outline-primary'"
                @click="Dashboard3"
                >{{ $t("GetAuctionInfoByStatusShop") }}</b-button
              >
            </b-button-group>
            <b-row class="mt-3">
              <b-col sm="12" md="2" lg="2">
                <custom-date-picker
                  v-model="filter2.StartDate"
                  format="DD.MM.YYYY"
                  type="date"
                  :clearable="false"
                  :placeholder="$t('StartDate')"
                  @keyup="BindValueStart"
                >
                </custom-date-picker>
              </b-col>
              <b-col sm="12" md="2" lg="2">
                <custom-date-picker
                  v-model="filter2.EndDate"
                  format="DD.MM.YYYY"
                  type="date"
                  :clearable="false"
                  :placeholder="$t('EndDate')"
                  @keyup="BindValueEndDate"
                >
                </custom-date-picker>
              </b-col>
              <b-col md="3" cols="12">
                <v-select
                  :options="OblastList"
                  :reduce="(item) => item.id"
                  :placeholder="$t('SelectOblast')"
                  label="name"
                  @input="OblastChange"
                  v-model="filter2.OblastId"
                ></v-select>
              </b-col>
              <b-col cols="12" md="3">
                <v-select
                  :options="RegionList"
                  :reduce="(item) => item.id"
                  :placeholder="$t('SelectRegion')"
                  label="name"
                  @input="RegionChange"
                  v-model="filter2.RegionId"
                ></v-select>
              </b-col>
            </b-row>
            <apexchart
              type="bar"
              height="350"
              :options="dashboardChart1.chartOptions"
              :series="dashboardChart1.series"
            >
            </apexchart>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <h3>{{ $t("infografika") }}</h3>
          <dashboard-component></dashboard-component>
          <!-- <img
            :src="imgSrc"
            style="width: 100%"
            class="mt-3"
            @click="singleImage = true"
            alt=""
          />
          <vue-easy-lightbox
            :visible="singleImage"
            :imgs="imgSrc"
            @hide="singleImage = false"
          ></vue-easy-lightbox> -->
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import ReportService from "@/services/reports/report.service";
import DashboardService from "../services/reports/dashboard.service";
import UzexService from "@/services/others/uzex.service";
//import imgSrc from "@/assets/images/infografika.svg";
import DashboardComponent from "../components/dashboardcomponent.vue";
import TradeTypeRestrictionService from "@/services/info/tradetyperestriction.service";
import VueEasyLightbox from "vue-easy-lightbox";
import CustomDatePicker from "../components/customDatePicker.vue";
import OblastService from "@/services/info/oblast.service";
export default {
  components: { Layout, VueEasyLightbox, CustomDatePicker, DashboardComponent },
  data() {
    return {
      imgSrc: "",
      tabIndex: 0,
      OblastList: [],
      RegionList: [],
      dashboard1: {
        series: [],
        chartOptions: {},
      },
      dashboard2: {
        series: [],
        chartOptions: {},
      },
      dashboard3: {
        series: [],
        chartOptions: {},
      },
      dashboard4: {
        series: [],
        chartOptions: {},
      },
      dashboard5: {
        series: [],
        chartOptions: {},
      },
      dashboard6: {
        series: [],
        chartOptions: {},
      },
      dashboardChart1: {
        series: [],
        chartOptions: {},
      },
      barChart: {
        series: [
          {
            data: [380, 430, 450, 475, 550, 584, 780, 1100, 1220, 1365],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          colors: ["#34c38f"],
          grid: {
            borderColor: "#f1f1f1",
          },
          xaxis: {
            categories: [
              "South Korea",
              "Canada",
              "United Kingdom",
              "Netherlands",
              "Italy",
              "France",
              "Japan",
              "United States",
              "China",
              "Germany",
            ],
          },
        },
      },
      barChart1: {
        series: [
          {
            data: [380, 430, 450, 475, 550, 584, 780, 1100, 1220, 1365],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          colors: ["#556EE6"],
          grid: {
            borderColor: "#f1f1f1",
          },
          xaxis: {
            categories: [
              "South Korea",
              "Canada",
              "United Kingdom",
              "Netherlands",
              "Italy",
              "France",
              "Japan",
              "United States",
              "China",
              "Germany",
            ],
          },
        },
      },
      data: {},
      data1: {
        series: [159036293, 6194329, 88952, 14027201, 2970292],
        chartOptions: {
          labels: [
            this.$t("donecosttotal"),
            this.$t("paidcosttotal"),
            this.$t("newcosttotal"),
            this.$t("notdeliveredcosttotal"),
            this.$t("notpaidcosttotal"),
          ],
          chart: {
            type: "donut",
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
      },
      filter: {
        StartDate: "01.01.2023",
        EndDate: "30.09.2024",
        OblastId: 0,
        RegionId: 0,
        LotId: 0,
        ProductCategoryId: 0,
        TradeTypeId: 0,
      },
      filter2: {
        StartDate: "01.01.2024",
        EndDate: "31.12.2024",
        OblastId: 0,
        RegionId: 0,
        LotId: 0,
        ItemGroupName: "",
      },
      singleImage: false,
      dashboardLoading: false,
    };
  },
  created() {
    // console.log(this.$can("RoleView","permissions"))
    if (this.$can("GetReportPurchaseRequisitionView", "permissions")) {
      this.Refresh();
      this.Dashboard1();
      UzexService.GetAllAuctionOblast().then((res) => {
        this.OblastList = res.data.result;
      });
    }
    TradeTypeRestrictionService.GetImageForDashboard().then((res) => {
      this.imgSrc = res.data;
    });
  },
  methods: {
    OblastChange() {
      if (this.filter2.OblastId != 0) {
        this.filter2.RegionId = 0;
        if (!!this.filter2.OblastId) {
          UzexService.GetAllAuctionRegion(this.filter2.OblastId).then((res) => {
            this.RegionList = res.data.result;
          });
        }
      }
      if (this.filter2.OblastId == null) {
        this.filter2.OblastId = 0;
      }
      if (this.tabIndex == 0) {
        this.Dashboard1();
      } else if (this.tabIndex == 1) {
        this.Dashboard2();
      } else {
        this.Dashboard3();
      }
    },
    RegionChange() {
      if (this.filter2.RegionId == null) {
        this.filter2.RegionId = 0;
      }
      if (this.tabIndex == 0) {
        this.Dashboard1();
      } else if (this.tabIndex == 1) {
        this.Dashboard2();
      } else {
        this.Dashboard3();
      }
    },
    BindValueStart(value) {
      this.filter2.StartDate = value;
    },
    BindValueEndDate(value) {
      this.filter2.EndDate = value;
    },
    BindValueStartDate(value) {
      this.filter.StartDate = value;
    },
    BindValueEndDate1(value) {
      this.filter.EndDate = value;
    },
    Dashboard1() {
      this.tabIndex = 0;
      this.dashboardLoading = true;
      DashboardService.GetAuctionInfoByStatusAuction(
        this.filter2.StartDate,
        this.filter2.EndDate,
        this.filter2.OblastId,
        this.filter2.RegionId,
        this.filter2.LotId,
        this.filter2.ItemGroupName
      )
        .then((res) => {
          console.log(res);
          this.dashboardChart1 = {
            series: [
              {
                name: this.$t("totalcost"),
                data: res.data.data.map((item) => item.totalcost),
              },
              {
                name: this.$t("totalcount"),
                data: res.data.data.map((item) => item.totalcount),
              },
            ],
            chartOptions: {
              chart: {
                toolbar: {
                  show: false,
                },
              },
              plotOptions: {
                bar: {
                  horizontal: true,
                },
              },
              dataLabels: {
                enabled: false,
              },
              // tooltip: {
              // y: {
              //   formatter: function (val) {
              //     return this.$options?.filters?.currency(val, {
              //       symbol: "",
              //       thousandsSeparator:'',
              //       fractionCount: 2,
              //     })
              //   }
              // },

              // },
              colors: ["#34c38f", "#556EE6"],
              grid: {
                borderColor: "#f1f1f1",
              },
              xaxis: {
                categories:
                  this.filter2.OblastId == 0
                    ? res.data.data.map((item) => item.oblastname)
                    : this.filter2.OblastId != 0 && this.filter2.RegionId != 0
                    ? res.data.data.map((item) => item.buyername)
                    : res.data.data.map((item) => item.regionname),
              },
            },
          };
        })
        .catch((error) => {
          console.log(error);
          this.$notification(error.response?.data?.error, "danger");
        })
        .finally(() => {
          this.dashboardLoading = false;
        });
    },
    Dashboard2() {
      this.tabIndex = 1;
      this.dashboardLoading = true;
      DashboardService.GetAuctionInfoByStatusEtender(
        this.filter2.StartDate,
        this.filter2.EndDate,
        this.filter2.OblastId,
        this.filter2.RegionId,
        this.filter2.LotId,
        this.filter2.ItemGroupName
      )
        .then((res) => {
          this.dashboardChart1 = {
            series: [
              {
                name: this.$t("totalcost"),
                data: res.data.result.data.map((item) => item.totalcost),
              },
              {
                name: this.$t("totalcount"),
                data: res.data.result.data.map((item) => item.totalcount),
              },
            ],
            chartOptions: {
              chart: {
                toolbar: {
                  show: false,
                },
              },
              plotOptions: {
                bar: {
                  horizontal: true,
                },
              },
              dataLabels: {
                enabled: false,
              },
              // tooltip: {
              //   y: {
              //     formatter: function (val) {
              //       return this.$options.filters.currency(val, {
              //                   symbol: "  ",
              //                   fractionCount: 2,
              //                 })
              //     }
              //   }
              // },
              colors: ["#34c38f", "#556EE6"],
              grid: {
                borderColor: "#f1f1f1",
              },
              xaxis: {
                categories:
                  this.filter2.OblastId == 0
                    ? res.data.result.data.map((item) => item.oblastname)
                    : this.filter2.OblastId != 0 && this.filter2.RegionId != 0
                    ? res.data.result.data.map((item) => item.buyername)
                    : res.data.result.data.map((item) => item.regionname),
              },
            },
          };
        })
        .catch((error) => {
          this.$notification(error.response?.data?.error, "danger");
        })
        .finally(() => {
          this.dashboardLoading = false;
        });
    },
    Dashboard3() {
      this.tabIndex = 2;
      this.dashboardLoading = true;
      DashboardService.GetAuctionInfoByStatusShop(
        this.filter2.StartDate,
        this.filter2.EndDate,
        this.filter2.OblastId,
        this.filter2.RegionId,
        this.filter2.LotId,
        this.filter2.ItemGroupName
      )
        .then((res) => {
          this.dashboardChart1 = {
            series: [
              {
                name: this.$t("totalcost"),
                data: res.data.result.data.map((item) => item.totalcost),
              },
              {
                name: this.$t("totalcount"),
                data: res.data.result.data.map((item) => item.totalcount),
              },
            ],
            chartOptions: {
              chart: {
                toolbar: {
                  show: false,
                },
              },
              plotOptions: {
                bar: {
                  horizontal: true,
                },
              },
              dataLabels: {
                enabled: false,
              },
              // tooltip: {
              //   y: {
              //     formatter: function (val) {
              //       return this.$options.filters.currency(val, {
              //                   symbol: "  ",
              //                   fractionCount: 2,
              //                 })
              //     }
              //   }
              // },
              colors: ["#34c38f", "#556EE6"],
              grid: {
                borderColor: "#f1f1f1",
              },
              xaxis: {
                categories:
                  this.filter2.OblastId == 0
                    ? res.data.result.data.map((item) => item.oblastname)
                    : this.filter2.OblastId != 0 && this.filter2.RegionId != 0
                    ? res.data.result.data.map((item) => item.buyername)
                    : res.data.result.data.map((item) => item.regionname),
              },
            },
          };
        })
        .catch((error) => {
          this.$notification(error.response?.data?.error, "danger");
        })
        .finally(() => {
          this.dashboardLoading = false;
        });
    },
    Refresh() {
      this.isBusy = true;
      this.refresh1();
      this.refresh2();
      this.refresh3();
      this.refresh4();
      this.refresh5();
      this.refresh6();
    },
    refresh1() {
      ReportService.GetReportForDashboard(
        1,
        this.filter.StartDate,
        this.filter.EndDate
      ).then((res) => {
        this.dashboard1 = {
          series: [
            {
              name: this.$t("totalcost"),
              data: res.data.map((item) => item.all_price),
            },
          ],
          chartOptions: {
            chart: {
              toolbar: {
                show: false,
              },
            },
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            dataLabels: {
              enabled: false,
            },
            colors: ["#556EE6"],
            grid: {
              borderColor: "#f1f1f1",
            },
            xaxis: {
              categories: res.data.map((item) => item.oblastname),
            },
          },
        };
      });
    },
    refresh2() {
      ReportService.GetReportForDashboard(
        2,
        this.filter.StartDate,
        this.filter.EndDate
      ).then((res) => {
        this.dashboard2 = {
          series: [
            {
              name: this.$t("totalcost"),
              data: res.data.map((item) => item.all_price),
            },
          ],
          chartOptions: {
            chart: {
              toolbar: {
                show: false,
              },
            },
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            dataLabels: {
              enabled: false,
            },
            colors: ["#556EE6"],
            grid: {
              borderColor: "#f1f1f1",
            },
            xaxis: {
              categories: res.data.map((item) => item.oblastname),
            },
          },
        };
      });
    },
    refresh3() {
      ReportService.GetReportForDashboard(
        3,
        this.filter.StartDate,
        this.filter.EndDate
      ).then((res) => {
        this.dashboard3 = {
          series: [
            {
              name: this.$t("totalcost"),
              data: res.data.map((item) => item.all_price),
            },
          ],
          chartOptions: {
            chart: {
              toolbar: {
                show: false,
              },
            },
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            dataLabels: {
              enabled: false,
            },
            colors: ["#556EE6"],
            grid: {
              borderColor: "#f1f1f1",
            },
            xaxis: {
              categories: res.data.map((item) => item.oblastname),
            },
          },
        };
      });
    },
    refresh4() {
      ReportService.GetReportForDashboard(
        4,
        this.filter.StartDate,
        this.filter.EndDate
      ).then((res) => {
        this.dashboard4 = {
          series: [
            {
              name: this.$t("totalcost"),
              data: res.data.map((item) => item.all_price),
            },
          ],
          chartOptions: {
            chart: {
              toolbar: {
                show: false,
              },
            },
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            dataLabels: {
              enabled: false,
            },
            colors: ["#556EE6"],
            grid: {
              borderColor: "#f1f1f1",
            },
            xaxis: {
              categories: res.data.map((item) => item.oblastname),
            },
          },
        };
      });
    },
    refresh5() {
      ReportService.GetReportForDashboard(
        5,
        this.filter.StartDate,
        this.filter.EndDate
      ).then((res) => {
        this.dashboard5 = {
          series: [
            {
              name: this.$t("totalcost"),
              data: res.data.map((item) => item.all_price),
            },
          ],
          chartOptions: {
            chart: {
              toolbar: {
                show: false,
              },
            },
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            dataLabels: {
              enabled: false,
            },
            colors: ["#556EE6"],
            grid: {
              borderColor: "#f1f1f1",
            },
            xaxis: {
              categories: res.data.map((item) => item.oblastname),
            },
          },
        };
      });
    },
    refresh6() {
      ReportService.GetReportForDashboard(
        6,
        this.filter.StartDate,
        this.filter.EndDate
      ).then((res) => {
        this.dashboard6 = {
          series: [
            {
              name: this.$t("totalcost"),
              data: res.data.map((item) => item.all_price),
            },
          ],
          chartOptions: {
            chart: {
              toolbar: {
                show: false,
              },
            },
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            dataLabels: {
              enabled: false,
            },
            colors: ["#556EE6"],
            grid: {
              borderColor: "#f1f1f1",
            },
            xaxis: {
              categories: res.data.map((item) => item.oblastname),
            },
          },
        };
      });
    },
  },
};
</script>
